import { render, staticRenderFns } from "./InspectionArticleReadStatusBadge.vue?vue&type=template&id=c69bf54c&scoped=true"
import script from "./InspectionArticleReadStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionArticleReadStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionArticleReadStatusBadge.vue?vue&type=style&index=0&id=c69bf54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69bf54c",
  null
  
)

export default component.exports